import React from "react";

import "dayjs/locale/en-gb";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormControl } from "@mui/material";
import { useField, useFormikContext } from "formik";
import dayjs from "dayjs";

const DateSelectorWrapper = ({ name, ...otherProps }) => {
  const [field, mata] = useField(name);
  const { setFieldValue } = useFormikContext();

  const configTextfield = {
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
  };

  if (mata && mata.touched && mata.error) {
    configTextfield.error = true;
    configTextfield.helperText = mata.error;
  }

  const handleChange = (e) => {
    setFieldValue(name, e);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <FormControl fullWidth>
        <DatePicker
          variant="inline"
          inputFormat="DD/MM/YYYY"
          value={dayjs(field.value)}
          {...configTextfield}
          inputVariant="outlined"
          onChange={handleChange}
          fullWidth
        />
      </FormControl>
    </LocalizationProvider>
  );
};

export default DateSelectorWrapper;
